import { render, staticRenderFns } from "./PuzzleMagnify.vue?vue&type=template&id=0ec793f2&scoped=true&"
import script from "./PuzzleMagnify.vue?vue&type=script&lang=js&"
export * from "./PuzzleMagnify.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleMagnify.vue?vue&type=style&index=0&id=0ec793f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec793f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
